import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';

import { UNDERSCORE } from '../../../../shared/utils/constant';
import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { AqdbBatch } from '../../../models/aqdb-batch';
import { AqdbCompleteFlag } from '../../../models/aqdb-constants';
import { DimensionPipe } from '../../../../shared/pipes/format-dimension.pipe';
import { NumberPipe } from '../../../../shared/pipes/number.pipe';
import { CoilSegment } from '../../../models/coil-segment';

@Component({
	selector: 'copo-metal-unit',
	templateUrl: './metal-unit.component.html',
	styleUrl: '../aqdb-batch-card.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatExpansionModule,
		TranslateModule,
		MatDividerModule,
		NumberPipe,
		DimensionPipe,
		NgSwitch,
		NgSwitchCase,
		NgSwitchDefault,
	]
})
export class MetalUnitComponent {
	@Input() batchData?: AqdbBatch;
	readonly UNDERSCORE = UNDERSCORE;

	readonly SLAB_VALUE = '04';
	readonly BLANKS_VALUE = '08';
	readonly COIL_VALUE = '06';
	readonly HEAVY_PLATE_VALUE = '09';
	readonly MIXED_COIL_VALUE = '16';
	readonly SCROLLED_SHEET_VALUE = '15';
	readonly SHEET_VALUE = '07';
	readonly SLIT_COIL_VALUE = '12';
	readonly THICK_PLATE_VALUE = '10';
	readonly WELDED_COIL_VALUE = '17';

	isComplete(batchData: AqdbBatch) {
		return batchData.completeFlag === AqdbCompleteFlag.COMPLETE;
	}

	isInComplete(batchData: AqdbBatch) {
		return batchData.completeFlag === AqdbCompleteFlag.INCOMPLETE;
	}

	getMinSegmentMarkedIdentity(batchData: AqdbBatch) {
		const minSegment = batchData.segments
			.reduce(
				(p: CoilSegment | undefined, c: CoilSegment) => !p || c.number < p.number ? c : p,
				undefined
			);
		return minSegment?.markedIdentity;
	}
}
